// Products a staff operator can define a catalogue for. Keyed by the ENTITLEMENTS
// product id (the id the catalogue API uses) — the same hyphenated id the hub
// ProductKey uses. Standalone from productCatalogue
// (customer tiles): different concept — catalogue-bearing products, not home-grid tiles.
// Only ids the entitlements service actually references are listed; add a product here
// once its catalogue exists. Display metadata is static, frontend-owned (product-as-data
// / logo upload are out of scope per EIT-82).
export type CatalogueProduct = { id: string; name: string; logo: string };

export const catalogueProducts: readonly CatalogueProduct[] = [
  { id: 'guardian', name: 'Guardian', logo: '/logo-guardian.png' },
  { id: 'foundry-flow', name: 'Foundry Flow', logo: '/logo-foundry_flow.png' },
] as const;

export const DEFAULT_CATALOGUE_PRODUCT = catalogueProducts[0].id;
